import { useCallback, useEffect, useState } from 'react';
import config from '../../shared/config';
import { SiteSettingsFlags } from '../../siteadmin/models/SiteSettings';

/**
 * Load domain flags for a tenant.
 * @param tenant Tenant whose flags to call, e.g. "demo".
 */
const useDomainFlags = (tenant: string) => {
  const [flagsLoading, setFlagsLoading] = useState(true);
  const [flagsError, setFlagsError] = useState<string>();
  const [flags, setFlags] = useState<SiteSettingsFlags>();

  const refetch = useCallback(() => {
    setFlags(undefined);
    setFlagsError(undefined);
    setFlagsLoading(true);
    fetch(`${config.API}/api/domain/list/domain/flags/client/${tenant}`)
      .then((res) => res.json())
      .then(setFlags)
      .catch((err) => {
        setFlagsError(`${err}`);
        setFlags({
          // Assume we require email verification if we can't load the flags.
          requireEmailVerification: true
        });
      })
      .finally(() => setFlagsLoading(false));
  }, [tenant]);

  useEffect(() => refetch(), [refetch]);

  return {
    flagsLoading,
    flagsError,
    flags
  };
};

export default useDomainFlags;
